import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';

interface ConfirmRelationshipRemovalModalProps {
  description: string;
  onCancel: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
}

const ConfirmRelationshipRemovalModal: React.FC<
  ConfirmRelationshipRemovalModalProps
> = ({ description, onCancel, onConfirm, isProcessing }) => {
  return (
    <div className='audit-add-modal-cont'>
      <div className='audit-add-modal-cont-head'>
        <div className='audit-add-modal-head-cont'>
          <div className='audit-add-modal-head-cont-icons'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path
                d='M12 9V13'
                stroke='#F79009'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M12 17.01L12.01 16.9989'
                stroke='#F79009'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M10.29 3.85998L2.82003 17C2.64599 17.3027 2.55458 17.6461 2.55502 17.9955C2.55545 18.3449 2.64772 18.6881 2.8225 18.9904C2.99728 19.2927 3.24899 19.5434 3.55134 19.7178C3.85368 19.8922 4.19698 19.9841 4.54641 19.984H19.4536C19.803 19.9841 20.1463 19.8922 20.4487 19.7178C20.751 19.5434 21.0027 19.2927 21.1775 18.9904C21.3523 18.6881 21.4446 18.3449 21.445 17.9955C21.4454 17.6461 21.354 17.3027 21.18 17L13.71 3.85998C13.5332 3.56151 13.2809 3.32077 12.9781 3.16397C12.6753 3.00718 12.3337 2.94092 11.9937 2.972C11.6538 3.00309 11.3296 3.13073 11.0594 3.33941C10.7891 3.5481 10.5835 3.82937 10.465 4.15279C10.4297 4.25087 10.404 4.35244 10.3881 4.45592C10.3586 4.65631 10.3639 4.86079 10.4037 5.05836C10.4436 5.25592 10.5173 5.44335 10.6204 5.61231L10.29 3.85998Z'
                stroke='#F79009'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <div className='audit-add-modal-head-cont-supporting'>
            <h1>Remove relationship</h1>
            <p>{description}</p>
          </div>
        </div>
        <div className='audit-add-modal-head-close' onClick={onCancel}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
          >
            <path
              d='M18 6L6 18M6 6L18 18'
              stroke='#85888E'
              strokeWidth='2'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      </div>
      <div className='audit-modal-cont-footer'>
        <div className='audit-modal-cont-footer-content'>
          <div
            className='audit-modal-cont-footer-content-btn-cancel'
            onClick={onCancel}
          >
            <div className='audit-modal-cont-footer-content-btn-text'>
              Go back
            </div>
          </div>
          <div
            className='audit-modal-cont-footer-content-btn-delete'
            onClick={onConfirm}
          >
            <div
              className='audit-modal-cont-footer-content-btn-text'
              style={{ color: '#FFF' }}
            >
              {isProcessing ? (
                <>
                  <CircularProgress
                    style={{ width: '30px', height: '30px', marginRight: '10px' }}
                    color='error'
                  />{' '}
                  Removing
                </>
              ) : (
                <>Remove relationship</>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmRelationshipRemovalModal;
